import React from 'react';

export type CartItemProps = {
  membership: string;
  name: string;
  price: number;
  amount: number;
};

export type CartContextType = {
  items: CartItemProps[],
  totalAmount: number,
  membershipString: string,
  addItem?: (item: CartItemProps) => void,
  removeItem?: (id: string) => void,
  emptyCart?: () => void
}

const CartContext = React.createContext<CartContextType>({
  items: [],
  totalAmount: 0,
  membershipString: ''
});

export default CartContext;
